import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b4a73686&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=b4a73686&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports